<div class="parking-slot">
  <div *ngIf="roleName !== userRoles.SUPER_ADMIN" class="card breadcrumbs">
    <div class="common-justify-wrap card-container purple-container">
      <ul class="list-none breadcrumbs-outer">
        <li class="active-dashboard">
          <a [routerLink]="['/manager/dashboard']" class="common-underline">Dashboard</a>
        </li>
        <li class="px-2 breadcrumbs-divider">
          <span>|</span>
        </li>
        <li class="back-link">
          <a [routerLink]="['/manager/parking']" class="common-underline">Parking Locations</a>
        </li>
        <li class="px-2 breadcrumbs-divider">
          <span>|</span>
        </li>
        <li class="current-link">
          <span class="line-height-3">Edit Parking</span>
        </li>
      </ul>
    </div>
  </div>
  <p-toast></p-toast>
  <div [formGroup]="parkingSlotForm" class="grid">
    <div class="col-12 md:col-6">
      <div class="box-card card">
        <div class="create-parking-slot">
          <div class="top-card">
            <div class="parking-lots-outer">
              <h3>Edit Parking</h3>
            </div>
            <div class="slot-tabs">
              <ul>
                <li *ngIf="selectedTab === 'defineSlots'" [ngClass]="{'tabs-active': selectedTab === 'defineSlots'}">
                  Define spots</li>
                <li *ngIf="selectedTab === 'parkAnywhere'" [ngClass]="{'tabs-active': selectedTab === 'parkAnywhere'}">
                  Park anywhere</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="grid threshold">
          <div class="col-12 md:col-6 custom-spacing-right">
            <div class="left-lable">
              Total Number of Spots <span class="custom-star">*</span>
            </div>
            <p-inputNumber inputId="locale-user" formControlName="totalSlots" placeholder="0"></p-inputNumber>
            <div
              *ngIf="parkingSlotForm.get('totalSlots')?.hasError('required') && (parkingSlotForm.get('totalSlots')?.dirty || parkingSlotForm.get('totalSlots')?.touched)">
              <div class="validation-error">This field is required*</div>
            </div>
            <div
              *ngIf="parkingSlotForm.get('totalSlots').hasError('lessThanThousand') && parkingSlotForm.get('totalSlots').touched && parkingSlotForm.get('totalSlots').dirty">
              <div class="validation-error">Spots cannot exceed 999</div>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="left-lable threshold-icon">
              <div class="thersold-text">
                Threshold (%) <span class="custom-star">*</span>
              </div>
              <div class="thersold-tooltip">
                <app-tooltip [tooltipMessage]="Threshold"></app-tooltip>
              </div>
            </div>

            <input pInputText class="common-input" (keypress)="onKeyPress($event)" inputId="locale-user" placeholder=""
              formControlName="thresholdValue">
            <div
              *ngIf="parkingSlotForm.get('thresholdValue')?.hasError('required') && (parkingSlotForm.get('thresholdValue')?.dirty || parkingSlotForm.get('thresholdValue')?.touched)">
              <div class="validation-error">This field is required*</div>
            </div>

            <div
              *ngIf="parkingSlotForm.get('thresholdValue')?.value === 0 && (parkingSlotForm.get('thresholdValue')?.dirty || parkingSlotForm.get('thresholdValue')?.touched)">
              <div class="validation-error">Threshold should be greater than 0</div>
            </div>
            <div
              *ngIf="parkingSlotForm.get('thresholdValue')?.hasError('lessThanHundred')  && (parkingSlotForm.get('thresholdValue')?.dirty || parkingSlotForm.get('thresholdValue')?.touched)">
              <div class="validation-error">Threshold cannot exceed 100%</div>
            </div>
          </div>
        </div>
        <div class="row-divider" formArrayName="truckTypeArray"
          [style.display]="selectedTab === 'defineSlots' ? 'block' : 'none'"
          *ngFor="let truck of truckTypeArray?.controls; let i=index">
          <div [formGroupName]="i">
            <div class="no-slot common-flex-between">
              <div class="left-lable">
                <div class="left-lable">
                  {{spotTypeMsg}} <span class="custom-star">*</span>
                </div>
                <div class="right-input ">
                  <label [for]="truck.get('truckName')!.value">{{truck.get('truckName')!.value }}</label>
                </div>
              </div>
              <div class="right-input custom-rightinput">
                <input (change)="slotChange(truck)" avoidStartingZero pKeyFilter="int" pInputText placeholder="0"
                  inputId="locale-user" formControlName="totalSlots">
                <div
                  *ngIf="truck.get('totalSlots')?.hasError('required')  && (truck.get('totalSlots')?.dirty || truck.get('totalSlots')?.touched)">
                  <div class="validation-error"> This field is required*</div>
                </div>
                <div
                  *ngIf="truck.get('totalSlots').hasError('lessThanThousand') && truck.get('totalSlots').touched && truck.get('totalSlots').dirty">
                  <div class="validation-error">Cannot exceed 999</div>
                </div>
              </div>
            </div>
            <div class="badge-box" formArrayName="parkingSlots">
              <h4>Spots Range</h4>
              <div class="slout-outer">
                <span *ngFor="let slot of parkingSlotArray(i)?.controls; let slotIndex=index">
                  <span [formGroupName]="slotIndex">
                    <input pInputText styleClass="mr-2 mb-2" formControlName="slotName" />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6">
      <div class="box-card card">
        <div class="upload-plan">
          <h3>Upload Plan</h3>
          <p>Parking plan maximum file size - 25 MB
          <div class="main-upload">
            <div *ngIf="upldBtn" class="upload-btn" (drop)="onDrop($event,fileUpload)" (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)">
              <p-fileUpload mode="basic" #fileUpload chooseLabel="Browse Computer" class="custom-ptext"
                (onSelect)="onUpload($event.files,fileUpload)">
                <div class="img-overlap" [style.background-image]="'url(' + imageLink + ')'"></div>
              </p-fileUpload>
              <p>Drag and drop your file or</p>
            </div>
          </div>
          <div *ngIf="isProfileImgError">
            <div class="validation-error">File size should be less than 25MB.</div>
          </div>
          <div class="pre-img upload-preimg" style="position: relative;">
            <p-image [src]="imageLink" *ngIf="imageLink" alt="preview-image" class="preview-image"
              [preview]="true"></p-image>
            <span *ngIf="delIcon"><em class="pi pi-times" (click)="deleteDocument()"></em></span>
          </div>
          <a *ngIf="isParkingLotLayoutDoc && pdfUrl" [href]="pdfUrl" target="_blank">
            <span>View Document</span>
          </a>
          <div class="formgrid grid next-btn save-btn">
            <p-button label="Save" class="" (onClick)="editParking()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>